import Row from 'antd/es/grid/row'
import {
  IdeaHistoryDef,
  PnlSummary,
} from '../../../../../apis/idea/idea-api.def.ts'
import Col from 'antd/es/grid/col'
import IdeyaTypography from '../../../../../common/antd/ideya-typography.tsx'
import { marketDateTimezoneFormatter } from '../../../../../utils/formatters.ts'
import { useAppSelector } from '../../../../../redux/hooks.ts'
import { selectThemeStyle } from '../../../../../features/setting/setting.slice.ts'
import { useTranslation } from 'react-i18next'
import { IdeaActionLogTable } from './idea-action-log-table.tsx'

interface IdeaActionLogsProps {
  actionLog: IdeaHistoryDef
  pnlData: PnlSummary
}

export const IdeaActionLog: React.FC<IdeaActionLogsProps> = ({
  actionLog,
  pnlData,
}) => {
  const { t } = useTranslation()
  const themeStyle = useAppSelector(selectThemeStyle)

  return (
    <>
      <Row>
        <Col span={6}>
          <IdeyaTypography.Text type={'secondary'}>
            {t('idea_list.idea_modal.idea_action_log.direction')}
          </IdeyaTypography.Text>
        </Col>
        <Col span={6}>
          <IdeyaTypography.Text type={'secondary'}>
            {t('idea_list.idea_modal.idea_action_log.date_open')}
          </IdeyaTypography.Text>
        </Col>
        <Col span={6}>
          <IdeyaTypography.Text type={'secondary'}>
            {t('idea_list.idea_modal.idea_action_log.date_closed')}
          </IdeyaTypography.Text>
        </Col>
        <Col span={6}>
          <IdeyaTypography.Text type={'secondary'}>
            {t('idea_list.idea_modal.idea_action_log.user')}
          </IdeyaTypography.Text>
        </Col>
      </Row>
      <Row>
        <Col span={6}>
          <IdeyaTypography.Text>
            {actionLog.idea.direction}
          </IdeyaTypography.Text>
        </Col>
        <Col span={6}>
          <IdeyaTypography.Text>
            {marketDateTimezoneFormatter(
              {
                value: actionLog.idea.createdAt.toString(),
                data: { marketTimeZone: actionLog.idea.marketTimeZone },
              },
              { showTimezone: true }
            )}
          </IdeyaTypography.Text>
        </Col>
        <Col span={6}>
          <IdeyaTypography.Text>
            {actionLog.idea.closedAt
              ? marketDateTimezoneFormatter(
                  {
                    value: actionLog.idea.closedAt.toString(),
                    data: { marketTimeZone: actionLog.idea.marketTimeZone },
                  },
                  { showTimezone: true }
                )
              : '-'}
          </IdeyaTypography.Text>
        </Col>
        <Col span={6}>
          <IdeyaTypography.Text>
            {actionLog.idea.contributor}
          </IdeyaTypography.Text>
        </Col>
      </Row>
      <Row
        style={{
          marginTop: themeStyle.marginSM,
          marginBottom: themeStyle.marginXS,
        }}
      >
        <IdeyaTypography.Title
          level={4}
          style={{ marginTop: themeStyle.marginSM }}
        >
          {t('idea_list.idea_modal.idea_action_log.action_log')}
        </IdeyaTypography.Title>
      </Row>
      <IdeaActionLogTable
        actionLog={actionLog}
        dailyPnlData={pnlData.dailyPnls}
      />
    </>
  )
}
